import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
} from "@angular/core";
import { ConfirmationService } from 'primeng/api';
import { AuthService } from "app/shared/services/auth.service";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { AnuncioService } from "../../services/anuncio.service";
import { AnuncioInteresse } from "../../models/anuncio-interesse.model";
import { Anuncio } from "../../models/anuncio.model";
import { UtilService } from "../../../shared/services/util.service";
import { MessageService } from "primeng/components/common/messageservice";
import { AnuncioInteresseService } from "../../services/anuncio-interesse.service";
import { CadastroAnuncioService } from "app/anuncio/services/cadastro-anuncio.service";
import { Router } from "@angular/router";
import { OrigemEnum } from "app/shared/enum/origem.enum";
import { AnuncioTipoEnum } from "app/shared/enum/anuncio-tipo.enum";
import { TagInterface } from "app/anuncio/models/comuns";

@Component({
  selector: "anuncio-anexo",
  templateUrl: "./anuncio-anexo.component.html",
  styleUrls: ["./anuncio-anexo.component.scss"],
})
export class AnuncioAnexoComponent implements OnInit {
  @Input()
  showUpload: boolean = false;

  @Input()
  anuncio: Anuncio | null = null;
  isDragging = false; // Controla se o arquivo está em cima do botão

  //evento para avisar que finalizou a análise
  @Output()
  alertaParaSeguir = new EventEmitter<boolean>();


  anexosList: TagInterface[] = [];
  defaultMaxFiles = 5;
  defaultMsgAlerta = "Os arquivos devem ser no formato PNG ou JPG e ter no máximo 30MB.";
  alerta: {
    show: boolean;
    tipo: "danger";
    mensagem: string;
  } = {
    show: false,
    tipo: "danger",
    mensagem: this.defaultMsgAlerta
  };
  constructor(
    private formBuilder: FormBuilder,
    private utilService: UtilService,
    private messageService: MessageService,
    private cadastroAnuncioService: CadastroAnuncioService,
      private authService: AuthService,
    private confirmationService: ConfirmationService,
    private anuncioService: AnuncioService,
    private router: Router,
    private anuncioInteresseService: AnuncioInteresseService,
  ) {}

  ngOnInit() {

      if(this.authService.isLoggedIn) {
        this.obterAnexos();
      }

  }
  @ViewChild("fileInput") fileInput!: ElementRef<HTMLInputElement>;

  filesRecords: File[] = [];
  accept = ".pdf";
  //30mb
  maxSize = 30 * 1024 * 1024;
  multiple = true;

  addFile() {
    this.fileInput.nativeElement.click();
  }

  handleFile(e: any) {
    const fileList = e.target.files;
    this.handleAddFile(fileList);
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  handleDrop(e: DragEvent) {
    e.preventDefault();
    e.stopPropagation();
    if (e.dataTransfer && e.dataTransfer.files) {
      const fileList = e.dataTransfer.files;
      this.handleAddFile(fileList);
    }
  }

  // Ativa o efeito visual ao entrar no botão
  onDragEnter(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = true;
  }

  // Desativa o efeito visual se o usuário tirar o arquivo de cima
  onDragLeave(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging = false;
  }

  handleAddFile(fileList: FileList | null) {
    this.isDragging = false;
    if (fileList) {
      const serverCount = this.anexosList ? this.anexosList.length : 0;
      const arrayFromFileList = Array.from(fileList);
      const localCount = arrayFromFileList ? arrayFromFileList.length : 0;
      if (serverCount + localCount > 5) {
        this.exibirAlerta("Quantidade máxima de anexos atingida. É permitido anexar até 5 arquivos por anúncio.");
        return;
      }
      for (const file of arrayFromFileList) {
        if (!this.checkAccept(file)) {
          this.exibirAlerta("Formato de arquivo não permitido.");
          return;
        }
        if (!this.checkSize(file)) {
          this.exibirAlerta("O tamanho do arquivo excede o limite permitido de " + this.calcSize(this.maxSize) + ".");
          return;
        }
      }
      if (this.multiple) {
        this.filesRecords = [...this.filesRecords, ...arrayFromFileList];
      } else {
        this.filesRecords = arrayFromFileList;
      }
      this.alertaParaSeguir.emit(this.filesRecords.length > 0);
    }
  }

  checkSize(file: File) {
    if (this.maxSize) {
      if (file.size > this.maxSize) {
        return false;
      }
    }
    return true;
  }

  checkAccept(file: File) {
    if (this.accept === "*") {
      return true;
    }
    const fileExtension = "." + file.name.split(".").pop();
    const acceptList = this.accept.split(",");
    for (const type of acceptList) {
      if (fileExtension.toLowerCase() === type.toLowerCase().trim()) {
        return true;
      }
    }
    return false;
  }

  calcSize(nBytes: number) {
    if (nBytes < 1024) {
      return `${nBytes} bytes`;
    }
    let sOutput = "";
    const aMultiples = ["KB", "MB", "GB", "TB"];
    let nMultiple = 0;
    let nApprox = nBytes / 1024;
    while (nApprox >= 1 && nMultiple < aMultiples.length) {
      sOutput = `${nApprox.toFixed(2)} ${aMultiples[nMultiple]}`;
      nApprox /= 1024;
      nMultiple++;
    }
    return sOutput;
  }

  handleRemoveFile(index: number) {
    const newFiles = [...this.filesRecords];
    newFiles.splice(index, 1);
    this.filesRecords = newFiles;
    this.alertaParaSeguir.emit(this.filesRecords.length > 0);
  }

  exibirAlerta(msg?: string) {
    this.alerta.show = true;
    if (msg) {
      this.alerta.mensagem = msg;
    } else {
      this.alerta.mensagem = this.defaultMsgAlerta;
    }
    setTimeout(() => {
      this.alerta.show = false;
    }, 5000);
  }

  realizarDownload(anexo: TagInterface) {
    if (this.anuncio && anexo.id) {
      this.anuncioService
        .obterAnexo(this.anuncio.id, anexo.id)
        .subscribe((blob) => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = anexo.nome;
          a.click();
          window.URL.revokeObjectURL(url);
        },
        (error) => {
          if(error.status === 404) {
             this.messageService.add({severity:'error', summary:'Erro ao baixar', detail:'Anexo não encontrado no servidor.'});
          } else {
            this.messageService.add({severity:'error', summary:'Erro', detail:error.message});
          }

        }
      );
    }
  }

  realizarUpload() {
    if (this.anuncio && this.filesRecords.length > 0) {
      this.anuncioService
        .realizarUpload(this.anuncio.id, this.filesRecords)
        .subscribe(() => {
          this.filesRecords = [];
          this.obterAnexos();
        });
        this.alertaParaSeguir.emit(false);
    }
  }

  obterTotalAnexos(): number {
    const servidorCount = this.anexosList ? this.anexosList.length : 0;
    const localCount = this.filesRecords ? this.filesRecords.length : 0;
    return servidorCount + localCount;
  }

  public obterAnexos() {
    if (this.anuncio) {
      this.anuncioService.obterAnexos(this.anuncio.id).subscribe((anexos) => {
        this.anexosList = anexos;
      });
    }
  }

  removerAnexo(anexo: TagInterface) {
    if (this.anuncio && anexo.id) {
      this.confirmationService.confirm({
        message: `Confirma a exclusão do Anexo <strong>${anexo.nome}</strong>? esta ação não pode ser desfeita.`,
        accept: () => {
          if (this.anuncio && anexo.id) {
            this.anuncioService
              .removerAnexo(this.anuncio.id, anexo.id)
              .subscribe(() => {
                this.obterAnexos();
              });
          }
        },
      });
    }
  }
}
